import initTabs from "../components/initTabs.js";

document.addEventListener("DOMContentLoaded", () => {

    // console.log("event.js");

    initTabs();

});
